// extracted by mini-css-extract-plugin
module.exports = {"iframe-overflow-wrapper":"IFrame_iframe-overflow-wrapper__Jf8Cf","iframe-webview-wrapper":"IFrame_iframe-webview-wrapper__3q1af"};